import { render } from "./Logo.vue?vue&type=template&id=7c72a98c"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"
script.render = render

export default script